export default "__VITE_ASSET__DUfbN6eH__"